{
  "filters": {
    "address": "Adresse",
    "update": "Mettre à jour",
    "name": "Nom de l'institution",
    "state": "État",
    "any": "Tous",
    "approved": "Approuvé",
    "rejected": "Refusé",
    "awaitingReview": "Examen en attente",
    "requestedDate": "Date de demande",
    "approvedDate": "Date d'approbation",
    "daysWaiting": "Jours d'attente",
    "document": "Document",
    "transitNumber": "Numéro de transit",
    "institutionNumber": "Numéro de l'institution",
    "bankAccountNumber": "Numéro de compte bancaire",
    "actions": "Actions",
    "stateOptions": {
      "AWAITING_REVIEW": "Examen en attente",
      "APPROVED": "Approuvé",
      "REJECTED": "Refusé"
    }
  },
  "institutionTransitions": {
    "approve": "Approuver",
    "reject": "Refuser"
  },
  "update": "Mettre à jour",
  "moderateInstitution": "Êtes-vous sûr?",
  "confirmationDialogTitle": "Voulez-vous vraiment {{transition}} ce compte bancaire?",
  "institutionPrefix": "Institution -",
  "addModal": {
    "title": "Créer une nouvelle institution",
    "address": "Adresse"
  }
}
